<div class="profile-preview">
  <app-avatar class="avatar" [user]="user || guest"></app-avatar>
  <div class="role-container" *ngIf="role$ | async as userRole">
    <div class="label in-flex label-{{ labelColor | async }}">{{ userRole | uppercase }}</div>
  </div>

  <div class="name" *ngIf="user">{{ user.first_name }} {{ user.last_name }}</div>
  <div class="name" *ngIf="guest">{{ guest.name }}</div>
  <div class="email">{{ email }}</div>

  <a
    [routerLink]="['/a/settings/people/' + (user ? 'user' : 'guest') + '/' + (user || guest)['id']]"
    target="_blank"
    appButton
    name="profile-button"
    location="profile-preview"
    shape="round"
    height="1"
    size="1"
    color="primary"
    [center]="true"
  >
    View Profile
  </a>
</div>
